/* La Peau — ventana compartida. window.LpModal.open(html, { narrow }) / LpModal.close(). */
(function () {
  if (window.LpModal) return;
  var scrim, modal, body, lastFocus = null;
  var CLOSE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function build() {
    if (modal) return;
    scrim = document.createElement('div');
    scrim.className = 'lp-modal-scrim';
    modal = document.createElement('div');
    modal.className = 'lp-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'lpModalTitle');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<button class="lp-modal__close" type="button" data-lp-modal-close aria-label="Cerrar">' + CLOSE + '</button><div class="lp-modal__body"></div>';
    body = modal.querySelector('.lp-modal__body');
    document.body.appendChild(scrim);
    document.body.appendChild(modal);
    scrim.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-lp-modal-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      // El foco no sale de la ventana mientras está abierta.
      var f = [].slice.call(modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea:not([hidden]), select, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function open(html, opts) {
    build();
    lastFocus = document.activeElement;
    body.innerHTML = html;
    body.scrollTop = 0;
    modal.classList.toggle('is-narrow', !!(opts && opts.narrow));
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-show');
    document.documentElement.classList.add('lp-modal-lock');
    setTimeout(function () { modal.querySelector('.lp-modal__close').focus({ preventScroll: true }); }, 50);
    return body;
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-show');
    document.documentElement.classList.remove('lp-modal-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  window.LpModal = { open: open, close: close, isOpen: function () { return !!modal && modal.classList.contains('is-open'); } };
})();
